module.exports = __webpack_public_path__ + "static/media/14.f294c3f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/14.jpg
// module id = 189
// module chunks = 0